import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// app/(homes)/(hrms)/hrms-software/attendance-management-system/real-time-attendance-tracking/page.jsx onto the content
// engine (template "hrmsFeature"). Copy, images, links and heading levels
// match the original. SEO still comes from GeneralPageSEOMetadata.json via
// <SEO> (its "real-time-attendance-tracking" entry is kept); the seo block below is a fallback.

export const realTimeAttendanceTracking: ContentPage = {
  slug: "attendance-management-system/real-time-attendance-tracking",
  template: "hrmsFeature",
  seo: {
    title: "Real-Time Employee Attendance Tracking System",
    description: "Track employee hours with real-time updates, biometric integration, and mobile access for efficient workforce management and accurate time tracking.",
    keywords: [
      "real-time attendance",
      "biometric attendance system",
      "mobile attendance tracking",
      "employee time tracking",
      "attendance alerts system.",
    ],
    ogImage: "/assets/data/seoimages/real-time-attendance-tracking.webp",
  },
  leaf: {
    hero: {
      caption: "Real-Time Attendance Tracking",
      title: "Monitor Work Hours with Real-Time Attendance Tracking",
      description: "Capture accurate employee attendance data in real-time, streamlining payroll processes and enhancing workforce management.",
      h1: "caption",
    },
    split: {
      title: "Seamless and Accurate Attendance Monitoring",
      bullets: [
        { title: "Biometric Integration", description: "Use fingerprint or facial recognition for clock-ins." },
        { title: "Mobile Clock-in", description: "Allow employees to record attendance on-the-go." },
        { title: "Alerts and Notifications", description: "Receive updates on unusual attendance patterns." },
        { title: "Real-Time Syncing", description: "Automatically update attendance records in real time." },
      ],
      image: "/assets/images/img/product/hrms/attendancems/real-time-attendance-tracking.webp",
      imageAlt: "real-time-attendance-tracking",
    },
    cardsHeading: {
      title: "Key Features of Attendance Management System",
      description: "Optimize Attendance management with advanced features designed to streamline tracking, automation, and customization.",
    },
    cards: [
      {
        title: "Absence Management",
        href: "/hrms-software/attendance-management-system/absence-management",
        description: "Efficiently manage and track employee absences and leaves with our comprehensive absence management system, reducing disruptions and ensuring compliance.",
        image: "/assets/images/img/product/hrms/attendancems/absence-management_key_features.webp",
        imageAlt: "absence-management_key_features",
      },
      {
        title: "Overtime Monitoring",
        href: "/hrms-software/attendance-management-system/overtime-monitoring",
        description: "Ensure fair compensation and compliance with our sophisticated overtime monitoring system, reducing discrepancies and boosting morale.",
        image: "/assets/images/img/product/hrms/attendancems/overtime-monitoring_key_features.webp",
        imageAlt: "Image Description",
      },
      {
        title: "Shift Management",
        href: "/hrms-software/attendance-management-system/shift-management",
        description: "Manage and automate employee shifts efficiently to ensure coverage and reduce scheduling conflicts with our advanced shift management tools.",
        image: "/assets/images/img/product/hrms/attendancems/shift_management_key_features.webp",
        imageAlt: "shift_management_key_features",
      },
      {
        title: "Geofencing Attendance",
        href: "/hrms-software/attendance-management-system/geofencing-attendance",
        description: "Utilize geofencing technology to manage employee attendance more securely and accurately, ideal for remote or on-site tracking.",
        image: "/assets/images/img/product/hrms/attendancems/geofencing_attendance_key_features.webp",
        imageAlt: "geofencing_attendance_key_features",
      },
    ],
    testimonials: {
      title: "200+ Businesses across India love & trust us!",
      description: "Know why Superworks is the best HR software in India",
    },
    bookDemoTitle: "Enhance Your Attendance Accuracy Today!",
    relatedBlogsKeyword: "hrms-real-time-attendance-tracking,hrms-overtime-monitoring,hrms-geofencing-attendance",
    metaKey: "real-time-attendance-tracking",
  },
  sections: [],
};
